



















import {Component, Vue} from 'vue-property-decorator';
import {Action, State} from "vuex-class";
import {LOGIN_ACTION} from "@/store/actions";

@Component({})
export default class App extends Vue {
    @Action(LOGIN_ACTION) public login!: any;

    @State('logged') public logged!: boolean;
}
